import { Injectable } from '@angular/core';

@Injectable()
export class ErrorMessageService {
	constructor() { }

	getErrorMessage(error: any): string {
		if(error && error.contents && error.contents.userMessage) {
			return error.contents.userMessage;
		} else if(error && error.returnMessage) {
			return error.returnMessage;
		} else if (error && error.message) {
			return error.message;
		}
		return "Unknown Error";
	}
}
